// import React from 'react';
// import './Button.css';
// import { Link } from 'react-router-dom';

// export function Button() {
//   return (
//     <Link to='sign-up'>
//       <button className='btn'>Sign Up</button>
//     </Link>
//   );
// }

import React from 'react';
import './ButtonLogout.css';
import { Link } from 'react-router-dom';
import { logout } from '../store/AccesTokenStore';


const STYLES = ['btn--primarylogout', 'btn--outlinelogout', 'btn--test'];

const SIZES = ['btn--mediumlogout', 'btn--large'];

export const ButtonLogout = ({
  children,
  type,
  buttonStyle,
  buttonSize
}) => {
  const checkButtonStyle = STYLES.includes(buttonStyle)
    ? buttonStyle
    : STYLES[0];

  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

  return (
    <Link to='/login' className='btn-mobile'>
      <button
        className={`btn ${checkButtonStyle} ${checkButtonSize}`}
        onClick={logout}
        type={type}
      >
        {children}
      </button>
    </Link>
  );
};
